import { menuItems } from './../../app/lib/constants/sidemenu/riyad-sidemenu.constants';
import { Theme } from '../theme.interface';
import { RiyadHomeComponent } from '@pages/home/components/riyad-home/riyad-home.component';

export const riyadConfig: Theme = {
    name: 'riyadConfig',
    properties: {
        '--font-family': '29LT Bukra',
        '--primary-color': '#2D124D',
        '--primary-color-light': '#2D124D',
        '--border-radius': '0.5rem',
        '--heading-font-size': '2rem',
    },
    assets: {
        clientName: 'Riyadh',
        otpFieldStyle: 'input-otp-box',
        loginSvg: 'assets/riyadh/login.svg',
        logoSvg: 'assets/riyadh/riyad-logo.png',
        sideMenu: menuItems,
        loginFlow: 'password',
        homeComponent: RiyadHomeComponent,
        allowedCountriesInPhoneSearch: ['ksa'],
        loginLayoutColumnLeft: 'col-lg-6',
        loginLayoutColumnRight: 'col-lg-6',
        favicon: 'assets/riyadh/favicon.png',
    },
};
